import { Outlet } from "react-router-dom";
import { useTenant } from "../context/TenantContext";

// Renders its children (or nested routes) only when the tenant's plan includes
// `feature` (e.g. "content_partners_portal"). Shows a notice instead of
// redirecting — creator accounts land on creator-only pages by default, so a
// redirect could bounce between two gated routes.
const RequireFeature = ({ feature, children }) => {
  const { hasFeature, tenantResolved } = useTenant();

  // Don't flash the notice while tenant-info is still loading.
  if (!tenantResolved) return null;

  if (!hasFeature(feature)) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "1.25rem", marginBottom: "8px" }}>Not available</h2>
        <p style={{ opacity: 0.7, maxWidth: 420 }}>
          This section isn&apos;t enabled for your account. Please contact support if you need access.
        </p>
      </div>
    );
  }

  return children ?? <Outlet />;
};

export default RequireFeature;
